/* src/app/shared/components/multiselect/multiselect.component.css */
:host ::ng-deep .p-multiselect-close {
  display: none !important;
}
:host ::ng-deep .p-multiselect {
  width: 100% !important;
  height: 32px;
}
:host ::ng-deep .p-multiselect.p-focus {
  border-color: #40a9ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
:host ::ng-deep .p-multiselect-label {
  display: flex;
  align-items: center;
}
:host ::ng-deep .p-multiselect-label-container {
  font-size: 14px !important;
}
:host ::ng-deep .p-multiselect-token {
  padding: 1px 4px !important;
}
:host ::ng-deep .p-checkbox {
  display: none !important;
}
:host ::ng-deep .p-multiselect-items {
  padding-left: 0;
}
:host ::ng-deep .p-multiselect-item {
  padding: 5px 12px;
}
:host ::ng-deep .p-multiselect-label.p-placeholder {
  color: #767676;
}
:host ::ng-deep .p-multiselect-token {
  background: #f5f5f5;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
}
::ng-deep .p-multiselect-item[data-p-highlight=true] {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  background-color: #e6f7ff;
}
.option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.checkmark-icon {
  color: #1890ff;
  font-size: 1rem;
  margin-left: auto;
}
::ng-deep .p-multiselect .p-multiselect-trigger {
  display: none !important;
}
.p-multiselect-token-icon {
  font-size: 0.8rem;
  cursor: pointer;
  color: #555;
  margin-left: 0.3rem;
  vertical-align: middle;
  line-height: 1;
}
/*# sourceMappingURL=multiselect.component-JFIBXD4U.css.map */
